export enum BlockType {
  Content = 'content',
  Columns = 'columns',
  Column = 'column',
  Badges = 'badges',
  Badge = 'badge',
}
